module.exports = __webpack_public_path__ + "img/fire.85c7827.png";